const prefix = '/api/payment';

const api = {
  getPaymentList: `${prefix}/parents/list`,
  getPaymentDetail: studentOrderNo => `${prefix}/parents/${studentOrderNo}`
};

export default {
  ...api
};
